export default {
	methods: {
		getGlideImage (image, width = 500, height = 500, type = 'asset', fit = 'crop') {
			let url = image?.path || image[0]?.path || image?.id || image[0]?.id || image || null
			let converted = false
			const format = 'webp'

			if (url) {
				if (url.includes('::')) {
					url = url.replace('::', '/')
					converted = true
				}
				if (type === 'asset') {
					return `/img/asset/${btoa(converted ? url : `images/${url}`)}?w=${width}&h=${height}&fm=${format}&fit=${fit}`
				}
				return `/img/${type}/${btoa(url)}?w=${width}&h=${height}&fm=${format}&fit=${fit}`
			}
			return null
		}
	}
}
